// extracted by mini-css-extract-plugin
export var equalColumn = "_ga-0";